import { Route } from '@angular/router';

export const ProductsRoute: Route = {
  path: 'products',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/products_shell'
    ).then((c) => c.ProductsShellRoutes);
  },
};
